module.exports = __webpack_public_path__ + "wasserzeichen.6d269d45c609503a6237.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/AnnaNorbisrath/WebstormProjects/me.rainer.surfschule-wiesensee/src/assets/img/wasserzeichen.jpg
// module id = ../../../../../src/assets/img/wasserzeichen.jpg
// module chunks = styles